var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100"},[_c('main-hero',{attrs:{"hero-title":_vm.$t('Welcome to Leads.io')}}),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('log-in-form')],1)]),_c('app-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }